import { render, staticRenderFns } from "./ErrorMessageDisplay.vue?vue&type=template&id=8f9a90c8&scoped=true"
import script from "./ErrorMessageDisplay.vue?vue&type=script&lang=js"
export * from "./ErrorMessageDisplay.vue?vue&type=script&lang=js"
import style0 from "./ErrorMessageDisplay.vue?vue&type=style&index=0&id=8f9a90c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a90c8",
  null
  
)

export default component.exports